import React, { useEffect, useState, useRef } from "react";
import * as urlService from "../view/urlService";
import { connect } from "react-redux";
import { debug, sortObjectsByAlphabet } from "../utils";
import * as groupService from "./gorupService";
import { useLocation } from "react-router-dom";
import { useDeviceTableHelper } from "./useDeviceTableHelper";
import { Check, ChevronDown } from 'lucide-react';

function GroupsDropdown({ groups }) {

    const location = useLocation();
    const devicesTableHelper = useDeviceTableHelper();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [groupId, setGroupId] = useState(-1);

    useEffect(() => {
        groupService.list();
        const group = urlService.getParams().f_groupId;
        setGroupId(group ? Number(group) : -1);
    }, [location.search])

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const onGroupChange = (value) => {
        devicesTableHelper.changeGroupFilter(value);
        setIsOpen(false);
    }

    const groupsCopy = sortObjectsByAlphabet(groups, 'name');
    const selectedGroup = groupsCopy.find(g => g.id === groupId) || groupsCopy[0];

    return (
        <div className="oct_custom-dropdown-v2" ref={dropdownRef}>
            <button
                type="button"
                className="oct_dropdown-button-v2"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="oct_dropdown-value">{selectedGroup?.name || 'All'}</span>
                <ChevronDown className="oct_dropdown-icon" />
            </button>

            {isOpen && (
                <div className="oct_dropdown-menu-v2">
                    {Array.isArray(groups) && groupsCopy.map((group, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`oct_dropdown-item-v2 ${group.id === groupId ? 'selected' : ''}`}
                            onClick={() => onGroupChange(group.id)}
                        >
                            <span>{group.name}</span>
                            {group.id === groupId && (
                                <Check className="oct_check-icon" />
                            )}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )

}

function mapStateToProps(state) {
    debug("GroupsDropdown mapStateToProps", state);
    const devicesPage = state.devicesPage;
    return {
        groups: devicesPage.groups || []
    };
}

export default connect(mapStateToProps)(GroupsDropdown);
